import Navbar from "./navbar"
import Footer from "./footer"

const Layout = ({ children }) => (
  <>
    <Navbar />
    <main className="min-h-[calc(100vh-155px)] w-full">{children}</main>
    <Footer id="footer" />
  </>
)

export default Layout
